import SuperRepository from '../superRepository'

export default new (class OrderWebRepository extends SuperRepository {
  baseUri() {
    return 'order'
  }
  list = async params => this.httpClient().get(`${this.baseUri()}/orders_web_list`, params)
})()
